import {Component, Inject, OnInit} from "@angular/core";
import {AlertService, AuthenticationService} from "../../_services";
import {Router} from "@angular/router";
import {LoginHelper} from "../../helpers";
import {User} from "../../_models";
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ImplementationControlStatement} from "../../_models/implementationControlStatement";
import {DictionaryService} from "../../_services/dictionary.service";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";

@Component({
  standalone: false,
  selector: "selectDiagramPosition-item",
  templateUrl: 'selectDiagramPosition.component.html',
  styleUrls: ['./selectDiagramPosition.component.scss'],
})
export class SelectDiagramPositionComponent {
  device: any = null;
  diagrams: any[] = [];
  devicePositions: any[] = [];
  currentDiagram = null;
  position: any;

  constructor(
    public authenticationService: AuthenticationService,
    public alertService: AlertService,
    public dictionaryService: DictionaryService,
    public formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) data: any,
    public dialogRef: MatDialogRef<SelectDiagramPositionComponent>) {
    this.device = data.device;
    this.diagrams = data.diagrams;
    this.devicePositions = data.devicePositions.map(p => ({...p}));
    this.currentDiagram = data.diagrams.find(d => this.devicePositions.find(s => d.id === s.diagramId)) || this.diagrams[0];
    this.position = this.devicePositions.find(s => s.diagramId === this.currentDiagram.id);
  }

  onClose(){
    this.dialogRef.close();
  }

  save() {
      this.dialogRef.close(this.devicePositions);
  }

  setPosition(event) {
    const x = event.offsetX / event.target.offsetWidth;
    const y = event.offsetY / event.target.offsetHeight;
    if (!this.position) {
      this.position = {diagramId: this.currentDiagram.id, deviceId: this.device.deviceId};
      this.devicePositions.push(this.position);
    }
    this.position.x = x;
    this.position.y = y;
  }

  onDiagramChange(diagram) {
    this.currentDiagram = diagram;
    this.position = this.devicePositions.find(s => s.diagramId === this.currentDiagram.id);
  }
}
